import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const scheduleStore = defineStore({
  id: 'schedule',
  state: () => ({
    loading: {
      techs: false
    },
    techs: [],
    currentTech: null
  }),
  actions: {
    async saveTechStatus(data) {
      let found = this.techs.find((x) => parseInt(x.contact) === parseInt(data.contact))
      if (found) {
        found.technicianStatus = parseInt(data.technicianStatus)
      }
      if (this.currentTech) {
        this.currentTech.technicianStatus = parseInt(data.technicianStatus)
      }
      console.log('Tech Status Updated', {
        techs: this.techs,
        found: found,
        data: data
      })
      return await api.post('schedule/technicianStatus', data)
    },
    async assignTechnician(data) {
      let results = await api.post('schedule/assignTechnician', data)
      await api.get(`opportunity/push?opportunity=${data.opportunity}&calibrateRequest=${data.calibrateRequest}`)
      return results
    },
    async unassignTech(data) {
      let results = await api.post('schedule/unassignTechnician', data)
      await api.get(`opportunity/push?opportunity=${data.opportunity}&calibrateRequest=${data.calibrateRequest}`)
      return results
    }
  }
})
